import React from 'react';

class ErrorBoundary extends React.Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false, error: null };
	}

	static getDerivedStateFromError(error) {
		return { hasError: true, error };
	}

	componentDidCatch(error, info) {
		console.error('ErrorBoundary caught an error:', error, info.componentStack);
	}

	render() {
		if (this.state.hasError) {
			return (
				<div
					style={{
						display: 'flex',
						flexDirection: 'column',
						alignItems: 'center',
						justifyContent: 'center',
						height: '100%',
						minHeight: '60vh',
						gap: '1rem',
						textAlign: 'center',
						padding: '2rem',
					}}>
					<div
						className='text-danger fw-bold'
						style={{ fontSize: 'calc(3rem + 3vw)' }}>
						500
					</div>
					<div
						className='text-dark fw-bold'
						style={{ fontSize: 'calc(1.5rem + 1.5vw)' }}>
						Something went wrong
					</div>
					<p className='text-muted'>
						An unexpected error occurred. Please try again or return to the home page.
					</p>
					<a
						href='/'
						className='btn btn-primary btn-lg px-5 py-3'>
						Go Home
					</a>
				</div>
			);
		}

		return this.props.children;
	}
}

export default ErrorBoundary;
